// extracted by mini-css-extract-plugin
module.exports = {"Text":"dogovor-oferty_Text__BJPeT"};